// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ITonnageRatingType {
    id: number;
    code: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class TonnageRatingType implements ITonnageRatingType, IBaseType {
    public id: number;
    public code: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns 1/4 TonnageRatingType
	**/
    get A(): ITonnageRatingType {
        return this.FromId(1);
    }
    /**
		Returns 1/2 TonnageRatingType
	**/
    get B(): ITonnageRatingType {
        return this.FromId(2);
    }
    /**
		Returns 1/2 - 3/4 TonnageRatingType
	**/
    get BC(): ITonnageRatingType {
        return this.FromId(3);
    }
    /**
		Returns 1/2 - 1 TonnageRatingType
	**/
    get BD(): ITonnageRatingType {
        return this.FromId(4);
    }
    /**
		Returns 1/2 - 1 1/2 TonnageRatingType
	**/
    get BE(): ITonnageRatingType {
        return this.FromId(5);
    }
    /**
		Returns 1/2 - 1 3/4 TonnageRatingType
	**/
    get BF(): ITonnageRatingType {
        return this.FromId(6);
    }
    /**
		Returns 3/4 TonnageRatingType
	**/
    get C(): ITonnageRatingType {
        return this.FromId(7);
    }
    /**
		Returns 3/4 - 1 TonnageRatingType
	**/
    get CD(): ITonnageRatingType {
        return this.FromId(8);
    }
    /**
		Returns 3/4 - 1 1/2 TonnageRatingType
	**/
    get CE(): ITonnageRatingType {
        return this.FromId(9);
    }
    /**
		Returns 3/4 - 1 3/4 TonnageRatingType
	**/
    get CF(): ITonnageRatingType {
        return this.FromId(10);
    }
    /**
		Returns 1 TonnageRatingType
	**/
    get D(): ITonnageRatingType {
        return this.FromId(11);
    }
    /**
		Returns 1 - 1 1/2 TonnageRatingType
	**/
    get DE(): ITonnageRatingType {
        return this.FromId(12);
    }
    /**
		Returns 1 - 2 TonnageRatingType
	**/
    get DG(): ITonnageRatingType {
        return this.FromId(13);
    }
    /**
		Returns 1 1/2 TonnageRatingType
	**/
    get E(): ITonnageRatingType {
        return this.FromId(14);
    }
    /**
		Returns 1 1/2 - 1 3/4 TonnageRatingType
	**/
    get EF(): ITonnageRatingType {
        return this.FromId(15);
    }
    /**
		Returns 1 1/2 - 2 TonnageRatingType
	**/
    get EG(): ITonnageRatingType {
        return this.FromId(16);
    }
    /**
		Returns 1 1/2 - 2  1/2 TonnageRatingType
	**/
    get EH(): ITonnageRatingType {
        return this.FromId(17);
    }
    /**
		Returns 1 1/2 - 3 TonnageRatingType
	**/
    get EI(): ITonnageRatingType {
        return this.FromId(18);
    }
    /**
		Returns 1 1/2 - 3 1/2 TonnageRatingType
	**/
    get EJ(): ITonnageRatingType {
        return this.FromId(19);
    }
    /**
		Returns 1 1/2 - 5 TonnageRatingType
	**/
    get EM(): ITonnageRatingType {
        return this.FromId(20);
    }
    /**
		Returns 1 3/4 TonnageRatingType
	**/
    get F(): ITonnageRatingType {
        return this.FromId(21);
    }
    /**
		Returns 1 3/4 - 2 1/2 TonnageRatingType
	**/
    get FH(): ITonnageRatingType {
        return this.FromId(22);
    }
    /**
		Returns 1 3/4 - 3 TonnageRatingType
	**/
    get FI(): ITonnageRatingType {
        return this.FromId(23);
    }
    /**
		Returns 1 3/4 - 4 1/2 TonnageRatingType
	**/
    get FL(): ITonnageRatingType {
        return this.FromId(24);
    }
    /**
		Returns 2 TonnageRatingType
	**/
    get G(): ITonnageRatingType {
        return this.FromId(25);
    }
    /**
		Returns 2 - 2 1/2 TonnageRatingType
	**/
    get GH(): ITonnageRatingType {
        return this.FromId(26);
    }
    /**
		Returns 2 - 3 TonnageRatingType
	**/
    get GI(): ITonnageRatingType {
        return this.FromId(27);
    }
    /**
		Returns 2 - 3 1/2 TonnageRatingType
	**/
    get GJ(): ITonnageRatingType {
        return this.FromId(28);
    }
    /**
		Returns 2 - 4 TonnageRatingType
	**/
    get GK(): ITonnageRatingType {
        return this.FromId(29);
    }
    /**
		Returns 2 - 4 1/2 TonnageRatingType
	**/
    get GL(): ITonnageRatingType {
        return this.FromId(30);
    }
    /**
		Returns 2 - 5 TonnageRatingType
	**/
    get GM(): ITonnageRatingType {
        return this.FromId(31);
    }
    /**
		Returns 2 - 6 TonnageRatingType
	**/
    get GN(): ITonnageRatingType {
        return this.FromId(32);
    }
    /**
		Returns 2 1/2 TonnageRatingType
	**/
    get H(): ITonnageRatingType {
        return this.FromId(33);
    }
    /**
		Returns 2 1/2 - 3 TonnageRatingType
	**/
    get HI(): ITonnageRatingType {
        return this.FromId(34);
    }
    /**
		Returns 2 1/2 - 3 1/2 TonnageRatingType
	**/
    get HJ(): ITonnageRatingType {
        return this.FromId(35);
    }
    /**
		Returns 2 1/2 - 4 TonnageRatingType
	**/
    get HK(): ITonnageRatingType {
        return this.FromId(36);
    }
    /**
		Returns 2 1/2 - 4 1/2 TonnageRatingType
	**/
    get HL(): ITonnageRatingType {
        return this.FromId(37);
    }
    /**
		Returns 2 1/2 - 5 TonnageRatingType
	**/
    get HM(): ITonnageRatingType {
        return this.FromId(38);
    }
    /**
		Returns 2 1/2 - 6 TonnageRatingType
	**/
    get HN(): ITonnageRatingType {
        return this.FromId(39);
    }
    /**
		Returns 2 1/2 - 7 TonnageRatingType
	**/
    get HO(): ITonnageRatingType {
        return this.FromId(40);
    }
    /**
		Returns 2 1/2 - 8 TonnageRatingType
	**/
    get HP(): ITonnageRatingType {
        return this.FromId(41);
    }
    /**
		Returns 2 1/2 - 9 TonnageRatingType
	**/
    get HQ(): ITonnageRatingType {
        return this.FromId(42);
    }
    /**
		Returns 2 1/2 - 10 TonnageRatingType
	**/
    get HR(): ITonnageRatingType {
        return this.FromId(43);
    }
    /**
		Returns 3 TonnageRatingType
	**/
    get I(): ITonnageRatingType {
        return this.FromId(44);
    }
    /**
		Returns 3 - 3 1/2 TonnageRatingType
	**/
    get IJ(): ITonnageRatingType {
        return this.FromId(45);
    }
    /**
		Returns 3 - 4 TonnageRatingType
	**/
    get IK(): ITonnageRatingType {
        return this.FromId(46);
    }
    /**
		Returns 3 - 4 1/2 TonnageRatingType
	**/
    get IL(): ITonnageRatingType {
        return this.FromId(47);
    }
    /**
		Returns 3 - 5 TonnageRatingType
	**/
    get IM(): ITonnageRatingType {
        return this.FromId(48);
    }
    /**
		Returns 3 - 6 TonnageRatingType
	**/
    get IN(): ITonnageRatingType {
        return this.FromId(49);
    }
    /**
		Returns 3 - 8 TonnageRatingType
	**/
    get IP(): ITonnageRatingType {
        return this.FromId(50);
    }
    /**
		Returns 3 1/2 TonnageRatingType
	**/
    get J(): ITonnageRatingType {
        return this.FromId(51);
    }
    /**
		Returns 3 1/2 - 4 TonnageRatingType
	**/
    get JK(): ITonnageRatingType {
        return this.FromId(52);
    }
    /**
		Returns 3 1/2 - 4 1/2 TonnageRatingType
	**/
    get JL(): ITonnageRatingType {
        return this.FromId(53);
    }
    /**
		Returns 3 1/2 - 5 TonnageRatingType
	**/
    get JM(): ITonnageRatingType {
        return this.FromId(54);
    }
    /**
		Returns 3 1/2 - 6 TonnageRatingType
	**/
    get JN(): ITonnageRatingType {
        return this.FromId(55);
    }
    /**
		Returns 3 1/2 - 8 TonnageRatingType
	**/
    get JP(): ITonnageRatingType {
        return this.FromId(56);
    }
    /**
		Returns 3 1/2 - 9 TonnageRatingType
	**/
    get JQ(): ITonnageRatingType {
        return this.FromId(57);
    }
    /**
		Returns 3 1/2 - 10 TonnageRatingType
	**/
    get JR(): ITonnageRatingType {
        return this.FromId(58);
    }
    /**
		Returns 4 TonnageRatingType
	**/
    get K(): ITonnageRatingType {
        return this.FromId(59);
    }
    /**
		Returns 4 -5 TonnageRatingType
	**/
    get KM(): ITonnageRatingType {
        return this.FromId(60);
    }
    /**
		Returns 4 - 6 TonnageRatingType
	**/
    get KN(): ITonnageRatingType {
        return this.FromId(61);
    }
    /**
		Returns 4 - 7 TonnageRatingType
	**/
    get KO(): ITonnageRatingType {
        return this.FromId(62);
    }
    /**
		Returns 4 - 8 TonnageRatingType
	**/
    get KP(): ITonnageRatingType {
        return this.FromId(63);
    }
    /**
		Returns 4 - 9 TonnageRatingType
	**/
    get KQ(): ITonnageRatingType {
        return this.FromId(64);
    }
    /**
		Returns 4 - 10 TonnageRatingType
	**/
    get KR(): ITonnageRatingType {
        return this.FromId(65);
    }
    /**
		Returns 4 1/2 TonnageRatingType
	**/
    get L(): ITonnageRatingType {
        return this.FromId(66);
    }
    /**
		Returns 4 1/2 - 5 TonnageRatingType
	**/
    get LM(): ITonnageRatingType {
        return this.FromId(67);
    }
    /**
		Returns 4 1/2 - 6 TonnageRatingType
	**/
    get LN(): ITonnageRatingType {
        return this.FromId(68);
    }
    /**
		Returns 4 1/2 - 8 TonnageRatingType
	**/
    get LP(): ITonnageRatingType {
        return this.FromId(69);
    }
    /**
		Returns 4 1/2 - 10 TonnageRatingType
	**/
    get LR(): ITonnageRatingType {
        return this.FromId(70);
    }
    /**
		Returns 5 TonnageRatingType
	**/
    get M(): ITonnageRatingType {
        return this.FromId(71);
    }
    /**
		Returns 5 - 6 TonnageRatingType
	**/
    get MN(): ITonnageRatingType {
        return this.FromId(72);
    }
    /**
		Returns 6 TonnageRatingType
	**/
    get N(): ITonnageRatingType {
        return this.FromId(73);
    }
    /**
		Returns 7 TonnageRatingType
	**/
    get O(): ITonnageRatingType {
        return this.FromId(74);
    }
    /**
		Returns 7 - 8 TonnageRatingType
	**/
    get OP(): ITonnageRatingType {
        return this.FromId(75);
    }
    /**
		Returns 8 TonnageRatingType
	**/
    get P(): ITonnageRatingType {
        return this.FromId(76);
    }
    /**
		Returns 9 TonnageRatingType
	**/
    get X1(): ITonnageRatingType {
        return this.FromId(78);
    }
    /**
		Returns 10 TonnageRatingType
	**/
    get R(): ITonnageRatingType {
        return this.FromId(77);
    }
    /**
		Returns 11 TonnageRatingType
	**/
    get X2(): ITonnageRatingType {
        return this.FromId(79);
    }
    /**
		Returns 12 TonnageRatingType
	**/
    get X3(): ITonnageRatingType {
        return this.FromId(80);
    }
    /**
		Returns 13 TonnageRatingType
	**/
    get X4(): ITonnageRatingType {
        return this.FromId(81);
    }
    /**
		Returns 14 TonnageRatingType
	**/
    get X5(): ITonnageRatingType {
        return this.FromId(82);
    }
    /**
		Returns 15 TonnageRatingType
	**/
    get X6(): ITonnageRatingType {
        return this.FromId(83);
    }
    /**
		Returns 16 TonnageRatingType
	**/
    get X7(): ITonnageRatingType {
        return this.FromId(84);
    }
    /**
		Returns 17 TonnageRatingType
	**/
    get X8(): ITonnageRatingType {
        return this.FromId(85);
    }
    /**
		Returns 18 TonnageRatingType
	**/
    get X9(): ITonnageRatingType {
        return this.FromId(86);
    }
    /**
		Returns 19 TonnageRatingType
	**/
    get X10(): ITonnageRatingType {
        return this.FromId(87);
    }
    /**
		Returns 20 TonnageRatingType
	**/
    get X11(): ITonnageRatingType {
        return this.FromId(88);
    }
    /**
		Returns 21 TonnageRatingType
	**/
    get X12(): ITonnageRatingType {
        return this.FromId(89);
    }
    /**
		Returns 22 TonnageRatingType
	**/
    get X13(): ITonnageRatingType {
        return this.FromId(90);
    }
    /**
		Returns 23 TonnageRatingType
	**/
    get X14(): ITonnageRatingType {
        return this.FromId(91);
    }
    /**
		Returns 24 TonnageRatingType
	**/
    get X15(): ITonnageRatingType {
        return this.FromId(92);
    }
    /**
		Returns 25 TonnageRatingType
	**/
    get X16(): ITonnageRatingType {
        return this.FromId(93);
    }
    /**
		Returns 26 TonnageRatingType
	**/
    get X17(): ITonnageRatingType {
        return this.FromId(94);
    }
    /**
		Returns 27 TonnageRatingType
	**/
    get X18(): ITonnageRatingType {
        return this.FromId(95);
    }
    /**
		Returns 28 TonnageRatingType
	**/
    get X19(): ITonnageRatingType {
        return this.FromId(96);
    }
    /**
		Returns 29 TonnageRatingType
	**/
    get X20(): ITonnageRatingType {
        return this.FromId(97);
    }
    /**
		Returns 30 TonnageRatingType
	**/
    get X21(): ITonnageRatingType {
        return this.FromId(98);
    }
    /**
		Returns 31 TonnageRatingType
	**/
    get X22(): ITonnageRatingType {
        return this.FromId(99);
    }
    /**
		Returns 32 TonnageRatingType
	**/
    get X23(): ITonnageRatingType {
        return this.FromId(100);
    }
    /**
		Returns 33 TonnageRatingType
	**/
    get X24(): ITonnageRatingType {
        return this.FromId(101);
    }
    /**
		Returns 34 TonnageRatingType
	**/
    get X25(): ITonnageRatingType {
        return this.FromId(102);
    }
    /**
		Returns 35 TonnageRatingType
	**/
    get X26(): ITonnageRatingType {
        return this.FromId(103);
    }
    /**
		Returns 36 TonnageRatingType
	**/
    get X27(): ITonnageRatingType {
        return this.FromId(104);
    }
    /**
		Returns 37 TonnageRatingType
	**/
    get X28(): ITonnageRatingType {
        return this.FromId(105);
    }
    /**
		Returns 38 TonnageRatingType
	**/
    get X29(): ITonnageRatingType {
        return this.FromId(106);
    }
    /**
		Returns 39 TonnageRatingType
	**/
    get X30(): ITonnageRatingType {
        return this.FromId(107);
    }
    /**
		Returns 40 TonnageRatingType
	**/
    get X31(): ITonnageRatingType {
        return this.FromId(108);
    }
    /**
		Returns Unknown TonnageRatingType
	**/
    get U(): ITonnageRatingType {
        return this.FromId(109);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, code: 'A', displayValue: '1/4', description: 'Quarter Ton', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, code: 'B', displayValue: '1/2', description: 'Half Ton', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, code: 'BC', displayValue: '1/2 - 3/4', description: 'Half Ton to Three Quarter Ton', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, code: 'BD', displayValue: '1/2 - 1', description: 'Half Ton to One Ton', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, code: 'BE', displayValue: '1/2 - 1 1/2', description: 'Half Ton to One and a Half Ton', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, code: 'BF', displayValue: '1/2 - 1 3/4', description: 'Half Ton to One and Three Quarter Ton', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, code: 'C', displayValue: '3/4', description: 'Three Quarter Ton', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, code: 'CD', displayValue: '3/4 - 1', description: 'Three Quarter Ton to One Ton', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, code: 'CE', displayValue: '3/4 - 1 1/2', description: 'Three Quarter Ton to One and a Half Ton', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, code: 'CF', displayValue: '3/4 - 1 3/4', description: 'Three Quarter Ton to One and Three Quarter Ton', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, code: 'D', displayValue: '1', description: 'One Ton', sortOrder: 11, active: true });
        this._dictionary.add('12', { id: 12, code: 'DE', displayValue: '1 - 1 1/2', description: 'One Ton to One and a Half Ton', sortOrder: 12, active: true });
        this._dictionary.add('13', { id: 13, code: 'DG', displayValue: '1 - 2', description: 'One Ton to Two Ton', sortOrder: 13, active: true });
        this._dictionary.add('14', { id: 14, code: 'E', displayValue: '1 1/2', description: 'One and a Half Ton', sortOrder: 14, active: true });
        this._dictionary.add('15', { id: 15, code: 'EF', displayValue: '1 1/2 - 1 3/4', description: 'One and a Half Ton to One and Three Quarter Ton', sortOrder: 15, active: true });
        this._dictionary.add('16', { id: 16, code: 'EG', displayValue: '1 1/2 - 2', description: 'One and a Half Ton to Two Ton', sortOrder: 16, active: true });
        this._dictionary.add('17', { id: 17, code: 'EH', displayValue: '1 1/2 - 2  1/2', description: 'One and a Half Ton to Two and a Half Ton', sortOrder: 17, active: true });
        this._dictionary.add('18', { id: 18, code: 'EI', displayValue: '1 1/2 - 3', description: 'One and a Half Ton to Three Ton', sortOrder: 18, active: true });
        this._dictionary.add('19', { id: 19, code: 'EJ', displayValue: '1 1/2 - 3 1/2', description: 'One and a Half Ton to Three and a Half Ton', sortOrder: 19, active: true });
        this._dictionary.add('20', { id: 20, code: 'EM', displayValue: '1 1/2 - 5', description: 'One and a Half Ton to Five Ton', sortOrder: 20, active: true });
        this._dictionary.add('21', { id: 21, code: 'F', displayValue: '1 3/4', description: 'One and Three Quarter Ton', sortOrder: 21, active: true });
        this._dictionary.add('22', { id: 22, code: 'FH', displayValue: '1 3/4 - 2 1/2', description: 'One and Three Quarter Ton to Two and a Half Ton', sortOrder: 22, active: true });
        this._dictionary.add('23', { id: 23, code: 'FI', displayValue: '1 3/4 - 3', description: 'One and Three Quarter Ton to Three Ton', sortOrder: 23, active: true });
        this._dictionary.add('24', { id: 24, code: 'FL', displayValue: '1 3/4 - 4 1/2', description: 'One and Three Quarter Ton to Four and a Half Ton', sortOrder: 24, active: true });
        this._dictionary.add('25', { id: 25, code: 'G', displayValue: '2', description: 'Two Ton', sortOrder: 25, active: true });
        this._dictionary.add('26', { id: 26, code: 'GH', displayValue: '2 - 2 1/2', description: 'Two Ton to Tow and a Half Ton', sortOrder: 26, active: true });
        this._dictionary.add('27', { id: 27, code: 'GI', displayValue: '2 - 3', description: 'Two Ton to Three Ton', sortOrder: 27, active: true });
        this._dictionary.add('28', { id: 28, code: 'GJ', displayValue: '2 - 3 1/2', description: 'Two Ton to Three and a Half Ton', sortOrder: 28, active: true });
        this._dictionary.add('29', { id: 29, code: 'GK', displayValue: '2 - 4', description: 'Two Ton to Four Ton', sortOrder: 29, active: true });
        this._dictionary.add('30', { id: 30, code: 'GL', displayValue: '2 - 4 1/2', description: 'Two Ton to Four and a Half Ton', sortOrder: 30, active: true });
        this._dictionary.add('31', { id: 31, code: 'GM', displayValue: '2 - 5', description: 'Two Ton to Five Ton', sortOrder: 31, active: true });
        this._dictionary.add('32', { id: 32, code: 'GN', displayValue: '2 - 6', description: 'Two Ton to Six Ton', sortOrder: 32, active: true });
        this._dictionary.add('33', { id: 33, code: 'H', displayValue: '2 1/2', description: 'Two and a Half Ton', sortOrder: 33, active: true });
        this._dictionary.add('34', { id: 34, code: 'HI', displayValue: '2 1/2 - 3', description: 'Two and a Half Ton to Three Ton', sortOrder: 34, active: true });
        this._dictionary.add('35', { id: 35, code: 'HJ', displayValue: '2 1/2 - 3 1/2', description: 'Two and a Half Ton to Three and a Half Ton', sortOrder: 35, active: true });
        this._dictionary.add('36', { id: 36, code: 'HK', displayValue: '2 1/2 - 4', description: 'Two and a Half Ton to Four Ton', sortOrder: 36, active: true });
        this._dictionary.add('37', { id: 37, code: 'HL', displayValue: '2 1/2 - 4 1/2', description: 'Two and a Half Ton to Four and a Half Ton', sortOrder: 37, active: true });
        this._dictionary.add('38', { id: 38, code: 'HM', displayValue: '2 1/2 - 5', description: 'Two and a Half Ton to Five Ton', sortOrder: 38, active: true });
        this._dictionary.add('39', { id: 39, code: 'HN', displayValue: '2 1/2 - 6', description: 'Two and a Half Ton to Six Ton', sortOrder: 39, active: true });
        this._dictionary.add('40', { id: 40, code: 'HO', displayValue: '2 1/2 - 7', description: 'Two and a Half Ton to Seven Ton', sortOrder: 40, active: true });
        this._dictionary.add('41', { id: 41, code: 'HP', displayValue: '2 1/2 - 8', description: 'Two and a Half Ton to Eight Ton', sortOrder: 41, active: true });
        this._dictionary.add('42', { id: 42, code: 'HQ', displayValue: '2 1/2 - 9', description: 'Two and a Half Ton to Nine Ton', sortOrder: 42, active: true });
        this._dictionary.add('43', { id: 43, code: 'HR', displayValue: '2 1/2 - 10', description: 'Two and a Half Ton to Ten Ton', sortOrder: 43, active: true });
        this._dictionary.add('44', { id: 44, code: 'I', displayValue: '3', description: 'Three Ton', sortOrder: 44, active: true });
        this._dictionary.add('45', { id: 45, code: 'IJ', displayValue: '3 - 3 1/2', description: 'Three Ton to Three and a Half Ton', sortOrder: 45, active: true });
        this._dictionary.add('46', { id: 46, code: 'IK', displayValue: '3 - 4', description: 'Three Ton to Four Ton', sortOrder: 46, active: true });
        this._dictionary.add('47', { id: 47, code: 'IL', displayValue: '3 - 4 1/2', description: 'Three Ton to Four and a Half Ton', sortOrder: 47, active: true });
        this._dictionary.add('48', { id: 48, code: 'IM', displayValue: '3 - 5', description: 'Three Ton to Five Ton', sortOrder: 48, active: true });
        this._dictionary.add('49', { id: 49, code: 'IN', displayValue: '3 - 6', description: 'Three Ton to Six Ton', sortOrder: 49, active: true });
        this._dictionary.add('50', { id: 50, code: 'IP', displayValue: '3 - 8', description: 'Three Ton to Eight Ton', sortOrder: 50, active: true });
        this._dictionary.add('51', { id: 51, code: 'J', displayValue: '3 1/2', description: 'Three and a Half Ton', sortOrder: 51, active: true });
        this._dictionary.add('52', { id: 52, code: 'JK', displayValue: '3 1/2 - 4', description: 'Three and a Half Ton to Four Ton', sortOrder: 52, active: true });
        this._dictionary.add('53', { id: 53, code: 'JL', displayValue: '3 1/2 - 4 1/2', description: 'Three and a Half Ton to Four and a Half Ton', sortOrder: 53, active: true });
        this._dictionary.add('54', { id: 54, code: 'JM', displayValue: '3 1/2 - 5', description: 'Three and a Half Ton to Five Ton', sortOrder: 54, active: true });
        this._dictionary.add('55', { id: 55, code: 'JN', displayValue: '3 1/2 - 6', description: 'Three and a Half Ton to Six Ton', sortOrder: 55, active: true });
        this._dictionary.add('56', { id: 56, code: 'JP', displayValue: '3 1/2 - 8', description: 'Three and a Half Ton to Eight Ton', sortOrder: 56, active: true });
        this._dictionary.add('57', { id: 57, code: 'JQ', displayValue: '3 1/2 - 9', description: 'Three and a Half Ton to Nine Ton', sortOrder: 57, active: true });
        this._dictionary.add('58', { id: 58, code: 'JR', displayValue: '3 1/2 - 10', description: 'Three and a Half Ton to Ten Ton', sortOrder: 58, active: true });
        this._dictionary.add('59', { id: 59, code: 'K', displayValue: '4', description: 'Four Ton', sortOrder: 59, active: true });
        this._dictionary.add('60', { id: 60, code: 'KM', displayValue: '4 -5', description: 'Four Ton to Five Ton', sortOrder: 60, active: true });
        this._dictionary.add('61', { id: 61, code: 'KN', displayValue: '4 - 6', description: 'Four Ton to Six Ton', sortOrder: 61, active: true });
        this._dictionary.add('62', { id: 62, code: 'KO', displayValue: '4 - 7', description: 'Four Ton to Seven Ton', sortOrder: 62, active: true });
        this._dictionary.add('63', { id: 63, code: 'KP', displayValue: '4 - 8', description: 'Four Ton to Eight Ton', sortOrder: 63, active: true });
        this._dictionary.add('64', { id: 64, code: 'KQ', displayValue: '4 - 9', description: 'Four Ton to Nine Ton', sortOrder: 64, active: true });
        this._dictionary.add('65', { id: 65, code: 'KR', displayValue: '4 - 10', description: 'Four Ton to Ten Ton', sortOrder: 65, active: true });
        this._dictionary.add('66', { id: 66, code: 'L', displayValue: '4 1/2', description: 'Four and a Half Ton', sortOrder: 66, active: true });
        this._dictionary.add('67', { id: 67, code: 'LM', displayValue: '4 1/2 - 5', description: 'Four and a Half Ton to Five Ton', sortOrder: 67, active: true });
        this._dictionary.add('68', { id: 68, code: 'LN', displayValue: '4 1/2 - 6', description: 'Four and a Half Ton to Six Ton', sortOrder: 68, active: true });
        this._dictionary.add('69', { id: 69, code: 'LP', displayValue: '4 1/2 - 8', description: 'Four and a Half Ton to Eight Ton', sortOrder: 69, active: true });
        this._dictionary.add('70', { id: 70, code: 'LR', displayValue: '4 1/2 - 10', description: 'Four and a Half Ton to Ten Ton', sortOrder: 70, active: true });
        this._dictionary.add('71', { id: 71, code: 'M', displayValue: '5', description: 'Five Ton', sortOrder: 71, active: true });
        this._dictionary.add('72', { id: 72, code: 'MN', displayValue: '5 - 6', description: 'Five Ton to Six Ton', sortOrder: 72, active: true });
        this._dictionary.add('73', { id: 73, code: 'N', displayValue: '6', description: 'Six Ton', sortOrder: 73, active: true });
        this._dictionary.add('74', { id: 74, code: 'O', displayValue: '7', description: 'Seven Ton', sortOrder: 74, active: true });
        this._dictionary.add('75', { id: 75, code: 'OP', displayValue: '7 - 8', description: 'Seven Ton to Eight Ton', sortOrder: 75, active: true });
        this._dictionary.add('76', { id: 76, code: 'P', displayValue: '8', description: 'Eight Ton', sortOrder: 76, active: true });
        this._dictionary.add('78', { id: 78, code: 'X1', displayValue: '9', description: 'Nine Ton', sortOrder: 77, active: true });
        this._dictionary.add('77', { id: 77, code: 'R', displayValue: '10', description: 'Ten Ton', sortOrder: 78, active: true });
        this._dictionary.add('79', { id: 79, code: 'X2', displayValue: '11', description: 'Eleven Ton', sortOrder: 79, active: true });
        this._dictionary.add('80', { id: 80, code: 'X3', displayValue: '12', description: 'Twelve Ton', sortOrder: 80, active: true });
        this._dictionary.add('81', { id: 81, code: 'X4', displayValue: '13', description: 'Thirteen Ton', sortOrder: 81, active: true });
        this._dictionary.add('82', { id: 82, code: 'X5', displayValue: '14', description: 'Fourteen Ton', sortOrder: 82, active: true });
        this._dictionary.add('83', { id: 83, code: 'X6', displayValue: '15', description: 'Fifteen Ton', sortOrder: 83, active: true });
        this._dictionary.add('84', { id: 84, code: 'X7', displayValue: '16', description: 'Sixteen Ton', sortOrder: 84, active: true });
        this._dictionary.add('85', { id: 85, code: 'X8', displayValue: '17', description: 'Seventeen Ton', sortOrder: 85, active: true });
        this._dictionary.add('86', { id: 86, code: 'X9', displayValue: '18', description: 'Eighteen Ton', sortOrder: 86, active: true });
        this._dictionary.add('87', { id: 87, code: 'X10', displayValue: '19', description: 'Nineteen Ton', sortOrder: 87, active: true });
        this._dictionary.add('88', { id: 88, code: 'X11', displayValue: '20', description: 'Twenty Ton', sortOrder: 88, active: true });
        this._dictionary.add('89', { id: 89, code: 'X12', displayValue: '21', description: 'Twenty One Ton', sortOrder: 89, active: true });
        this._dictionary.add('90', { id: 90, code: 'X13', displayValue: '22', description: 'Twenty Two Ton', sortOrder: 90, active: true });
        this._dictionary.add('91', { id: 91, code: 'X14', displayValue: '23', description: 'Twenty Three Ton', sortOrder: 91, active: true });
        this._dictionary.add('92', { id: 92, code: 'X15', displayValue: '24', description: 'Twenty Four Ton', sortOrder: 92, active: true });
        this._dictionary.add('93', { id: 93, code: 'X16', displayValue: '25', description: 'Twenty Five Ton', sortOrder: 93, active: true });
        this._dictionary.add('94', { id: 94, code: 'X17', displayValue: '26', description: 'Twenty Six Ton', sortOrder: 94, active: true });
        this._dictionary.add('95', { id: 95, code: 'X18', displayValue: '27', description: 'Twenty Seven Ton', sortOrder: 95, active: true });
        this._dictionary.add('96', { id: 96, code: 'X19', displayValue: '28', description: 'Twenty Eight Ton', sortOrder: 96, active: true });
        this._dictionary.add('97', { id: 97, code: 'X20', displayValue: '29', description: 'Twenty Nine Ton', sortOrder: 97, active: true });
        this._dictionary.add('98', { id: 98, code: 'X21', displayValue: '30', description: 'Thirty Ton', sortOrder: 98, active: true });
        this._dictionary.add('99', { id: 99, code: 'X22', displayValue: '31', description: 'Thirty One Ton', sortOrder: 99, active: true });
        this._dictionary.add('100', { id: 100, code: 'X23', displayValue: '32', description: 'Thirty Two Ton', sortOrder: 100, active: true });
        this._dictionary.add('101', { id: 101, code: 'X24', displayValue: '33', description: 'Thirty Three Ton', sortOrder: 101, active: true });
        this._dictionary.add('102', { id: 102, code: 'X25', displayValue: '34', description: 'Thirty Four Ton', sortOrder: 102, active: true });
        this._dictionary.add('103', { id: 103, code: 'X26', displayValue: '35', description: 'Thity Five Ton', sortOrder: 103, active: true });
        this._dictionary.add('104', { id: 104, code: 'X27', displayValue: '36', description: 'Thirty Six Ton', sortOrder: 104, active: true });
        this._dictionary.add('105', { id: 105, code: 'X28', displayValue: '37', description: 'Thirty Seven Ton', sortOrder: 105, active: true });
        this._dictionary.add('106', { id: 106, code: 'X29', displayValue: '38', description: 'Thirty Eight Ton', sortOrder: 106, active: true });
        this._dictionary.add('107', { id: 107, code: 'X30', displayValue: '39', description: 'Thirty Nine Ton', sortOrder: 107, active: true });
        this._dictionary.add('108', { id: 108, code: 'X31', displayValue: '40', description: 'Forty Ton', sortOrder: 108, active: true });
        this._dictionary.add('109', { id: 109, code: 'U', displayValue: 'Unknown', description: 'Unknown', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ITonnageRatingType {
        return this._dictionary[id];
    }

    public FromCode(code: string): ITonnageRatingType {
        var match = this._dictionary.getValues().filter(d => d.value == code);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ITonnageRatingType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ITonnageRatingType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ITonnageRatingType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
